<div class="bg-gray-950 h-full">
	@if (hasNoContents_()) {
		<div class="p-20 flex items-center justify-center">
			<ui-empty
				[preset]="UI_EMPTY_PRESET.NO_PREVIEW"
				[noStyle]="true"
				[theme]="'DARK'"
			/>
		</div>
	} @else if (docxPreviewDocId_()) {
		<app-documents-word-matter-viewer
			[documentId]="docxPreviewDocId_()"
			[showControls]="false"
		/>
	} @else if (form_()) {
		<app-matter-form-instance-viewer [form]="form_()" />
	} @else if (uploadedDocPreviewSourcePath_()) {
		<app-matter-url-pdf-viewer
			[googleSrcUrl]="uploadedDocPreviewSourcePath_()"
			[showMultiple]="true"
			class="h-full"
		/>
	} @else {
		<div class="p-20 w-full h-full flex items-center justify-center">
			<p class="p-sm text-white">Loading preview...</p>
		</div>
	}
</div>
